import { ArrowLeft, ArrowRight } from "lucide-react";
import React from "react";

interface PaginationProps {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  totalCount,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const getDisplayedPages = () => {
    let pages: number[] = [];
    if (totalPages <= 5) {
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, 5];
      } else if (currentPage + 2 >= totalPages) {
        pages = [
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        ];
      } else {
        pages = [
          currentPage - 2,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          currentPage + 2,
        ];
      }
    }
    return pages;
  };

  return (
    <div className="flex space-x-2 mb-2">
      {/* Previous button */}
      <button
        className="px-3 py-1 border rounded-lg bg-[#53A93D14] text-customGreenColor"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ArrowLeft size={16} />
      </button>

      {/* Page numbers */}
      {getDisplayedPages().map((page) => (
        <button
          key={page}
          className={`px-3 py-1 border rounded-lg ${
            currentPage === page
              ? "bg-customGreenColor text-white"
              : "bg-[#53A93D14] text-customGreenColor"
          }`}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </button>
      ))}

      {totalPages > 5 && currentPage + 2 < totalPages && (
        <span className="px-3 py-1 border rounded-lg bg-[#53A93D14] text-customGreenColor">
          ...
        </span>
      )}

      {/* Next button */}
      <button
        className="px-3 py-1 border rounded-lg bg-[#53A93D14] text-customGreenColor"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
      >
        <ArrowRight size={16} />
      </button>
    </div>
  );
};

export default Pagination;
